const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="flex flex-col items-center justify-center bg-blue-600 rounded-lg p-8">
            {/* Custom TS Logo Mark */}
            <div className="relative w-14 h-14 flex items-center justify-center mb-2">
              <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-14 h-14">
                <ellipse
                  cx="24" cy="24" rx="21" ry="9"
                  stroke="#ffffff"
                  strokeWidth="2.2"
                  fill="none"
                  transform="rotate(-20 24 24)"
                  strokeLinecap="round"
                  strokeDasharray="90 20"
                />
                <text
                  x="24" y="30"
                  textAnchor="middle"
                  fontFamily="'Georgia', serif"
                  fontWeight="700"
                  fontSize="18"
                  fill="#ffffff"
                  letterSpacing="-1"
                >TS</text>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-white tracking-wide">Top Shelf</h3>
            <p className="text-xs font-medium text-blue-200 tracking-widest uppercase mt-0.5">Solutions</p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mt-1 mr-3">
                  <i className="ri-map-pin-line text-blue-400"></i>
                </div>
                <p className="text-sm text-gray-300">2200 E Williams Field - #200, Gilbert, AZ 85295</p>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-line text-blue-400"></i>
                </div>
                <a href="mailto:info@topshelfsolutionsllc.com" className="text-sm text-gray-300 hover:text-blue-400 transition-colors">
                  info@topshelfsolutionsllc.com
                </a>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-line text-blue-400"></i>
                </div>
                <a href="tel:6023649710" className="text-sm text-gray-300 hover:text-blue-400 transition-colors">
                  602.364.9710
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <button
                onClick={() => scrollToSection('home')}
                className="flex items-center text-sm text-gray-300 hover:text-blue-400 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-s-line text-blue-400"></i>
                </div>
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="flex items-center text-sm text-gray-300 hover:text-blue-400 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-s-line text-blue-400"></i>
                </div>
                Services
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="flex items-center text-sm text-gray-300 hover:text-blue-400 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-s-line text-blue-400"></i>
                </div>
                About
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="flex items-center text-sm text-gray-300 hover:text-blue-400 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-s-line text-blue-400"></i>
                </div>
                Our Process
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="flex items-center text-sm text-gray-300 hover:text-blue-400 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-s-line text-blue-400"></i>
                </div>
                Contact
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="flex items-center text-sm text-gray-300 hover:text-blue-400 transition-colors whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-s-line text-blue-400"></i>
                </div>
                Testimonials
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <p className="text-center text-sm text-gray-400">
            © {new Date().getFullYear()} Top Shelf Solutions, LLC. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;